import { Navigate } from "react-router";
import { useAuth } from "../../application/useAuth";
import { JSX } from "react";
import { LoadingOverlay } from "../../../../shared/ui/common/LoadingOverlay";
import { useTranslation } from "react-i18next";

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated, emailVerified, loading } = useAuth();
  const { t } = useTranslation();

  if (loading) return <LoadingOverlay visible={true} message={t("common.loading")} />;

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  if (!emailVerified) return <Navigate to="/verify-email" replace />;

  return children;
}
